import { IManagingApplicationInstance } from '../api/models';
import { getAppEnvSortValue } from './EnvironmentHelpers';
import { Version } from './Version';

const versionSort = (left: Version, right: Version): number => {
    let result = right.major - left.major;
    if (result === 0) {
        result = right.minor - left.minor;
    }
    if (result === 0) {
        result = right.build - left.build;
    }
    if (result === 0) {
        result = right.revision - left.revision;
    }
    return result;
};

const sortByEnvironmentAndServerName = <T extends IManagingApplicationInstance>(list: Array<T>): Array<T> => {
    list.sort((a, b) => {
        const aEnv = getAppEnvSortValue(a.environment);
        const bEnv = getAppEnvSortValue(b.environment);
        if (aEnv === bEnv) {
            // order by server name within the same environment
            return a.serverName.localeCompare(b.serverName);
        }
        return bEnv - aEnv;
    });

    return list;
};

export { versionSort, sortByEnvironmentAndServerName };
